export default __webpack_public_path__ + "static/media/banner-unit-details.c40b25ee.png";